import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import {MatEditor} from "maticzeditor"
import config from "../../../lib/config";


const DeletePlanModal = (props) => {
    const {onplandel, Plans, customStyles, plandelete} = props
    const [showModel, setShowModel] = useState(true)

  return (
    <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>Delete Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className='newthememodal'>
                <div container className="mt-1" spacing={1}>
                        <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                          <Select
                            onChange={(e) => onplandel(e)}
                            options={Plans}
                            label="Single select"
                            isSearchable={false}
                            styles={customStyles}
                            classNamePrefix="react-select update_plan_top_slct"
                            formControlProps={{
                              fullWidth: true,
                            }}
                          />
                        </div>
                      </div>
                      <p className='fw-500 mt-3'>Are you sure you would like to delete this plan?</p>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          className="btn addcate mb-0 px-3 py-2"
                          onClick={(e) => plandelete(e)}
                        >
                          Delete
                        </button>

                        <button
                          className="graybtn px-3 py-2"
                          onClick={() => props.onDismiss()}
                        >
                          Cancel
                        </button>
                      </div>
                      </div>
                      </Modal.Body>
            </Modal>

    </div>
  )
}

export default DeletePlanModal